import { emitPromise } from '../utils/socketsHelpers';
import { GET_TAX_ENTRIES_FOR_APPROVAL } from '../shared/socketEvents.constants';

export const fetchTaxEntriesForApproval = socket => ({
  periodName,
}) => emitPromise(socket)(GET_TAX_ENTRIES_FOR_APPROVAL, { periodName });
